import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
  
})
export class AppComponent implements OnInit {
  title = 'app';
  logidin = true;
  showLoader: boolean;

  constructor(private router: Router) { }

  loginChange(data) {
   
    if (!data)
      this.logidin = false;
    else
      this.logidin = true;
  }

  ngOnInit() {
    //alert('hi3')
    let accessToken = localStorage.getItem('accessToken');
    let ref_url = window.location.href;
    if (accessToken != null && accessToken != "" && typeof accessToken != 'undefined'){
      this.logidin = false;
    }
    // else if (ref_url == 'https://portal.bshbvgsl.com/#/applicant-register') 
    //   {
    //   this.router.navigate(['/applicant-register']);
    //   } 
    //   else if (ref_url == 'https://portal.bshbvgsl.com/#/submitrequest-form') 
    //   {
    //   this.router.navigate(['/submitrequest-form']);
    //   }
    //   else if (ref_url == 'https://portal.bshbvgsl.com/#/applicant-login') 
    //   {
    //   this.router.navigate(['/applicant-login']);
    //   }
    //   else if (ref_url == 'https://portal.bshbvgsl.com/#/employee-login') 
    //   {
    //   this.router.navigate(['/employee-login']);
    //   }
    
    //   else if (ref_url  == 'https://portal.bshbvgsl.com/#/terms-condition' )
    //   {
    //     this.router.navigate(['/terms-condition']);
    //   }


//  else if (ref_url == 'https://erpbshbportal.bihar.gov.in/#/applicant-register') 
//       {
//       this.router.navigate(['/applicant-register']);
//       } 
//       else if (ref_url == 'https://erpbshbportal.bihar.gov.in/#/submitrequest-form') 
//       {
//       this.router.navigate(['/submitrequest-form']);
//       }
//       else if (ref_url == 'https://erpbshbportal.bihar.gov.in/#/applicant-login') 
//       {
//       this.router.navigate(['/applicant-login']);
//       }
//       else if (ref_url == 'https://erpbshbportal.bihar.gov.in/#/employee-login') 
//       {
//       this.router.navigate(['/employee-login']);
//       }
    
//       else if (ref_url  == 'https://erpbshbportal.bihar.gov.in/#/terms-condition' )
//       {
//         this.router.navigate(['/terms-condition']);
//       }

      // https://erpbshbportal.bihar.gov.in/#/terms-condition

    //   else{
    //     this.router.navigate(['/applicant-login']); // https://onlinebshb.esdinfra.com/#/home
    //   }

     else if (ref_url == 'https://portalbshb.esdinfra.com/#/applicant-register') 
      {
      this.router.navigate(['/applicant-register']);
      } 
      else if (ref_url == 'https://portalbshb.esdinfra.com/#/submitrequest-form') 
      {
      this.router.navigate(['/submitrequest-form']);
      }
      else if (ref_url == 'https://portalbshb.esdinfra.com/#/applicant-login') 
      {
      this.router.navigate(['/applicant-login']);
      }
        else if (ref_url == 'https://portalbshb.esdinfra.com/#/register') 
      {
      this.router.navigate(['/register']);
      }
      
      //https://portalbshb.esdinfra.com/#/register
      else if (ref_url == 'https://portalbshb.esdinfra.com/#/employee-login') 
      {
      this.router.navigate(['/employee-login']);
      }
      //  else if (ref_url == 'https://portalbshb.esdinfra.com/#/register') 
      // {
      //   this.router.navigate(['/register']);
      // }
      else if (ref_url  == 'https://portalbshb.esdinfra.com/#/terms-condition' )
      {
        this.router.navigate(['/terms-condition']);
      }
      else{
        //alert('hi')
        this.router.navigate(['/applicant-register']); // https://onlinebshb.esdinfra.com/#/home
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts